import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';

@Injectable()
export class ConfirmationPopupService {
	private readonly confirmationService = inject(ConfirmationService);
	private readonly translateService = inject(TranslateService);

	confirm(event: Event, accept: () => void) {
		this.confirmationService.confirm({
			target: event.currentTarget as EventTarget,
			message: this.translateService.instant('confirmation.question.delete'),
			icon: 'pi pi-info-circle',
			rejectButtonProps: {
				label: this.translateService.instant('shared.cancel'),
				severity: 'secondary',
				outlined: true,
			},
			acceptButtonProps: {
				label: this.translateService.instant('shared.delete'),
				severity: 'danger',
			},
			accept: () => {
				accept();
			},
		});
	}

	publish(event: Event, accept: () => void): void {
		this.confirmationService.confirm({
			target: event.currentTarget as EventTarget,
			message: this.translateService.instant('confirmation.question.publish'),
			icon: 'pi pi-info-circle',
			rejectButtonProps: {
				label: this.translateService.instant('shared.cancel'),
				severity: 'secondary',
				outlined: true,
			},
			acceptButtonProps: {
				label: this.translateService.instant('shared.publish'),
				severity: 'primary',
			},
			accept: () => {
				accept();
			},
		});
	}
}
